export default "__VITE_ASSET__IxEQbNyi__"